// extracted by mini-css-extract-plugin
var _1 = "Header_Header__g-Hd4";
var _2 = "Header_container__yXeTZ";
export { _1 as "Header", _2 as "container" }
